module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "membermanagement"
  }, [_c('a-layout', {
    staticStyle: {
      "min-height": "100vh"
    },
    attrs: {
      "id": "components-layout-demo-side"
    }
  }, [_c('menuBar', {
    attrs: {
      "current": _vm.current,
      "openKeys": _vm.openKeys
    }
  }), _vm._v(" "), _c('a-layout', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('topBar', {
    attrs: {
      "fatherMethod": _vm.initialize
    }
  }), _vm._v(" "), _c('a-layout-content', {
    staticStyle: {
      "margin": "16px",
      "min-width": "1192px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "line-height": "30px",
      "margin-bottom": "10px",
      "font-weight": "700",
      "padding-left": "8px"
    }
  }, [_vm._v("会员管理")]), _vm._v(" "), _c('div', {
    staticClass: "contentcard"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700"
    }
  }, [_vm._v("搜索会员")]), _vm._v(" "), _c('a-divider', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "dashed": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "min-width": "60px"
    }
  }, [_vm._v("微信昵称")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "260px",
      "margin-left": "5px",
      "margin-right": "40px"
    },
    attrs: {
      "placeholder": "请输入微信昵称"
    },
    model: {
      value: (_vm.searchlist.nick_name),
      callback: function($$v) {
        _vm.$set(_vm.searchlist, "nick_name", $$v)
      },
      expression: "searchlist.nick_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "min-width": "60px"
    }
  }, [_vm._v("微信号")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "260px",
      "margin-left": "5px",
      "margin-right": "40px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请输入微信号"
    },
    model: {
      value: (_vm.searchlist.wx_name),
      callback: function($$v) {
        _vm.$set(_vm.searchlist, "wx_name", $$v)
      },
      expression: "searchlist.wx_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "min-width": "60px"
    }
  }, [_vm._v("手机号")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "260px",
      "margin-left": "5px",
      "margin-right": "40px"
    },
    attrs: {
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.searchlist.phone_number),
      callback: function($$v) {
        _vm.$set(_vm.searchlist, "phone_number", $$v)
      },
      expression: "searchlist.phone_number"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "700",
      "display": "inline-block",
      "min-width": "60px"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "260px",
      "margin-left": "5px",
      "margin-right": "40px"
    },
    attrs: {
      "placeholder": "请输入ID"
    },
    model: {
      value: (_vm.searchlist.id),
      callback: function($$v) {
        _vm.$set(_vm.searchlist, "id", $$v)
      },
      expression: "searchlist.id"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a-button', {
    staticStyle: {
      "width": "96px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchbtn
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "contentcard"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('div', [(!_vm.memberlist.length) ? _c('div', [_c('a-alert', {
    attrs: {
      "message": "查询结果为空",
      "banner": "",
      "type": "info"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.memberlist.length) ? _c('div', [_c('a-row', {
    staticStyle: {
      "background-color": "#f3f3f5",
      "font-size": "14px",
      "height": "60px",
      "font-weight": "700"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("微信昵称")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("微信头像")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("手机号")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("会员等级")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("有效期")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("历史消费金额")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 5
    }
  }, [_vm._v("操作")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.memberlist), function(member) {
    return _c('div', {
      key: member.id,
      staticStyle: {
        "color": "#666",
        "font-size": "14px"
      }
    }, [_c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "padding": "10px 0"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [_c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v(_vm._s(member.id))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_c('a-popover', {
      attrs: {
        "trigger": "hover"
      }
    }, [_c('template', {
      slot: "content"
    }, [_c('p', [_vm._v(_vm._s(_vm.app_search(member.user_from_app)))])]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(member.nick_name) + "\n\t\t\t\t\t\t\t\t\t\t")], 2)], 1), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_c('img', {
      attrs: {
        "src": member.avatar_url,
        "height": "56"
      }
    })]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v(_vm._s(member.phone_number))]), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v(_vm._s(_vm.member_status[member.member_level]))]), _vm._v(" "), (member.timebuttonstatus == 0) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v(_vm._s(_vm.validity_time(member.validity_time)) + "\n\t\t\t\t\t\t\t\t\t\t"), _c('a-button', {
      staticStyle: {
        "font-size": "12px",
        "padding": "0",
        "margin-left": "5px"
      },
      attrs: {
        "type": "link",
        "size": "small"
      },
      on: {
        "click": function () {
          member.timebuttonstatus = 1
        }
      }
    }, [_vm._v("修改")])], 1) : _vm._e(), _vm._v(" "), (member.timebuttonstatus == 1) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_c('a-date-picker', {
      attrs: {
        "showToday": false
      },
      on: {
        "change": function($event) {
          return _vm.changevaliditytime($event, member)
        }
      }
    }, [_c('template', {
      slot: "renderExtraFooter"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.changetoperpetual(member)
        }
      }
    }, [_vm._v("永久")])]), _vm._v(" "), _c('a', [_vm._v(_vm._s(member.validity_time == 'perpetual' ? '永久' : member.validity_time))])], 2), _vm._v(" "), _c('a-button', {
      staticStyle: {
        "font-size": "12px",
        "padding": "0",
        "margin-left": "5px"
      },
      attrs: {
        "type": "link",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.savebtn(member)
        }
      }
    }, [_vm._v("保存")])], 1) : _vm._e(), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 2
      }
    }, [_vm._v("￥" + _vm._s(member.sumprice / 100))]), _vm._v(" "), (member.buttonstatus == 0) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [_c('a-button', {
      staticStyle: {
        "font-size": "12px",
        "padding": "0"
      },
      attrs: {
        "type": "link",
        "size": "small"
      },
      on: {
        "click": function () {
          member.buttonstatus = 1
        }
      }
    }, [_vm._v("修改等级")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "12px",
        "padding": "0"
      }
    }, [_vm._v("|")]), _vm._v(" "), _c('a-button', {
      staticStyle: {
        "font-size": "12px",
        "padding": "0"
      },
      attrs: {
        "type": "link",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.creditbtn(member)
        }
      }
    }, [_vm._v("积分管理")]), _vm._v(" "), (member.member_level == 1 || member.member_level == 2) ? _c('span', {
      staticStyle: {
        "font-size": "12px",
        "padding": "0"
      }
    }, [_vm._v("|")]) : _vm._e(), _vm._v(" "), (member.member_level == 1 || member.member_level == 2) ? _c('a-button', {
      staticStyle: {
        "font-size": "12px",
        "padding": "0"
      },
      attrs: {
        "type": "link",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.modifyagency(member)
        }
      }
    }, [_vm._v("代理修改")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (member.buttonstatus == 1) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 5
      }
    }, [_c('a-select', {
      staticStyle: {
        "width": "120px"
      },
      attrs: {
        "defaultValue": member.member_level
      },
      on: {
        "change": function($event) {
          return _vm.changememberlevel($event, member)
        }
      }
    }, [_c('a-select-option', {
      attrs: {
        "value": 1
      }
    }, [_vm._v("会员")]), _vm._v(" "), _c('a-select-option', {
      attrs: {
        "value": 2
      }
    }, [_vm._v("VIP会员")]), _vm._v(" "), _c('a-select-option', {
      attrs: {
        "value": 3,
        "disabled": ""
      }
    }, [_vm._v("钻石会员")]), _vm._v(" "), _c('a-select-option', {
      attrs: {
        "value": 4,
        "disabled": ""
      }
    }, [_vm._v("皇冠会员")])], 1), _vm._v(" "), _c('a-button', {
      staticStyle: {
        "font-size": "12px",
        "width": "96px"
      },
      attrs: {
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.savebtn(member)
        }
      }
    }, [_vm._v("保存")])], 1) : _vm._e()], 1)], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "position": "relative",
      "bottom": "-18px"
    }
  }, [_c('a-pagination', {
    attrs: {
      "showSizeChanger": "",
      "current": _vm.endpage / _vm.pageSize,
      "pageSize": _vm.pageSize,
      "total": _vm.membersum,
      "showQuickJumper": ""
    },
    on: {
      "showSizeChange": _vm.onShowSizeChange,
      "change": _vm.pageChange
    }
  })], 1)])])]), _vm._v(" "), _c('bottomBar')], 1)], 1), _vm._v(" "), _c('div', [_c('a-back-top')], 1), _vm._v(" "), _c('a-modal', {
    attrs: {
      "title": "代理修改",
      "visible": _vm.bianjivisible,
      "confirmLoading": _vm.confirmLoading
    },
    on: {
      "ok": _vm.bianjiOk,
      "cancel": _vm.bianjiCancel
    }
  }, [_c('div', {
    staticClass: "newcategory"
  }, [_c('span', {
    staticClass: "newcategorytext"
  }, [_vm._v("代理ID")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入代理ID"
    },
    model: {
      value: (_vm.bianjiagency.agency_user_id),
      callback: function($$v) {
        _vm.$set(_vm.bianjiagency, "agency_user_id", $$v)
      },
      expression: "bianjiagency.agency_user_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "newcategory"
  }, [_c('span', {
    staticClass: "newcategorytext"
  }, [_vm._v("绑定状态")]), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请选择绑定状态"
    },
    model: {
      value: (_vm.bianjiagency.bind_status),
      callback: function($$v) {
        _vm.$set(_vm.bianjiagency, "bind_status", $$v)
      },
      expression: "bianjiagency.bind_status"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("接洽中")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("下单中")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("已绑定")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40ee94a1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/membermanagement/index.vue
// module id = 2377
// module chunks = 1